import React, { Fragment } from 'react';
import { View } from 'react-native';
import { storiesOf } from '@storybook/react-native';
import { PanelHeader } from 'src/components/PanelHeader';
import { PlatformPadding } from 'src/components/PlatformPadding';
import { Separator } from 'src/components/Separator';
import { Group } from 'src/components/Group';
import { Button } from 'src/components/Button';
import { Spinner } from 'src/components/Spinner';

storiesOf('Spinner', module).add('Default', () => (
  <Fragment>
    <PanelHeader>⏳ Spinner</PanelHeader>
    <PlatformPadding vertical horizontal>
      <View>
        <Group separator={false}>
          <Spinner size="l" />
          <Separator size="xl" />
          <Spinner size="m" />
          <Separator size="xl" />
          <Spinner size="s" />
          <Separator size="xl" />
          <Spinner size="xs" />
          <Separator size="xl" />
          <Button size="l">
            <Spinner size="xs" color="#fff" />
          </Button>
        </Group>
      </View>
    </PlatformPadding>
  </Fragment>
));
